import { isOneOf } from "./isOneOf";

const nonOwaErrors: (string | RegExp)[] = [
    "chrome-extension://",
    "file:///",
    "btglss.net/",
    "(/Users/",
    "(/Applications/",
    /<anonymous>:\d+/,
];
export function isNonOwaError(callstack: string | undefined): boolean {
    return isOneOf(nonOwaErrors, callstack);
}
